<template #content>

    <div class="w-full">
        <div class="field mt-4 flex gap-2">
            <div class="w-6">
                <FloatLabel>
                    <InputText id="solicitante" v-model="form.solicitante" class="w-full" readonly />
                    <label for="solicitante">Solicitante</label>
                </FloatLabel>
            </div>

            <div class="w-6">
                <FloatLabel>
                    <InputText id="cliente" v-model="form.cliente" class="w-full" readonly />
                    <label for="cliente">Cliente</label>
                </FloatLabel>
            </div>
        </div>

        <div class="field mt-4 flex gap-2">
            <div class="w-3">
                <FloatLabel>
                    <InputText id="id_primario" v-model="form.id_primario" class="w-full" readonly />
                    <label for="id_primario">ID Primário</label>
                </FloatLabel>
            </div>

            <div class="w-3">
                <FloatLabel>
                    <InputText id="id_secundario" v-model="form.id_secundario" class="w-full" readonly />
                    <label for="id_secundario">ID Secundário</label>
                </FloatLabel>
            </div>

            <div class="w-6">
                <FloatLabel>
                    <InputText id="site" v-model="form.site" class="w-full" readonly />
                    <label for="site">Site/Localidade<span class="text-red-500">*</span></label>
                </FloatLabel>
            </div>
        </div>

        <Panel class="contrato-endereco mt-4" >
            <template #header>
                <div class="font-semibold">
                    <i class="pi pi-map-marker"></i> Endereço
                </div>
            </template>

            <div class="field mt-4 flex gap-2">
                <div class="w-4">
                    <InputGroup>
                        <FloatLabel>
                            <InputMask id="cep" v-model="form.cep" mask="99999-999" class="w-full" readonly />
                            <label for="cep">CEP</label>
                        </FloatLabel>
                    </InputGroup>
                </div>

                <div class="w-4">
                    <FloatLabel>
                        <InputText id="estado" v-model="form.estado" class="w-full"  readonly />
                        <label for="estado">Estado</label>
                    </FloatLabel>
                </div>

                <div class="w-4">
                    <FloatLabel>
                        <InputText id="cidade" v-model="form.cidade" class="w-full"  readonly />
                        <label for="cidade">Cidade</label>
                    </FloatLabel>
                </div>
            </div>

            <div class="field mt-4 flex gap-2">
                <div class="w-12">
                    <FloatLabel>
                        <InputText id="endereco1" v-model="form.endereco1" class="w-full" readonly />
                        <label for="endereco1">Logradouro</label>
                    </FloatLabel>
                </div>
            </div>

            <div class="field mt-4 flex gap-2">
                <div class="w-12">
                    <FloatLabel>
                        <InputText id="endereco2" v-model="form.endereco2" class="w-full" readonly />
                        <label for="endereco2">Complemento</label>
                    </FloatLabel>
                </div>
            </div>
        </Panel>

        <div class="field mt-4 flex gap-2">
            <div class="w-6">
                <FloatLabel>
                    <InputText id="provedor" v-model="form.provedor" class="w-full" readonly />
                    <label for="provedor">Provedor</label>
                </FloatLabel>
            </div>
        
            <div class="w-6">
                <FloatLabel>
                    <DatePicker 
                        id="data_instalacao" 
                        v-model="form.data_instalacao"
                        class="w-full"
                        dateFormat="dd/mm/yy"
                        showIcon
                        readonly />
                    <label for="data_instalacao">Data Instalação</label>
                </FloatLabel>
            </div>
        </div>

        <div class="field mt-4 flex gap-2">
            <div class="w-12">
                <FloatLabel>
                    <InputText id="instalador" v-model="form.instalador" class="w-full" readonly />
                    <label for="instalador">Instalador</label>
                </FloatLabel>
            </div>
        </div>

        <div class="field mt-4 flex gap-2">
            <div class="w-3">
                <InputGroup>
                    <FloatLabel>
                        <InputNumber v-model="form.cotacao_sla" fluid readonly />
                        <label>SLA</label>
                    </FloatLabel>
                    <InputGroupAddon>Horas</InputGroupAddon>
                </InputGroup>
            </div>

            <div class="w-2 flex align-content-center">
                <div class="flex align-items-center gap-2">
                    <Checkbox v-model="form.cotacao_sla_nbd" inputId="cotacao_sla_nbd" :trueValue="1" :falseValue="0" binary readonly />
                    <label for="cotacao_sla_nbd">NBD</label>
                </div>
            </div>

            <div class="w-4">
                <FloatLabel>
                    <InputText id="cotacao_velocidade" v-model="form.cotacao_velocidade" class="w-full" readonly />
                    <label for="cotacao_velocidade">Velocidade</label>
                </FloatLabel>
            </div>

            <div class="w-5">
                <FloatLabel>
                    <InputText id="cotacao_tipo_link" v-model="form.cotacao_tipo_link" class="w-full" readonly />
                    <label for="cotacao_tipo_link">Tipo de Link</label>
                </FloatLabel>
            </div>
        </div>

        <div class="field mt-4 flex gap-2">
            <div class="w-4">
                <InputGroup>
                    <InputGroupAddon>R$</InputGroupAddon>
                    <FloatLabel>
                        <InputNumber id="cotacao_valor" v-model="form.cotacao_valor" :minFractionDigits="2" :maxFractionDigits="5" fluid readonly />
                        <label for="cotacao_valor">Valor<span class="text-red-500">*</span></label>
                    </FloatLabel>
                </InputGroup>
            </div>
            <div class="w-4">
                <InputGroup>
                    <InputGroupAddon>R$</InputGroupAddon>
                    <FloatLabel>
                        <InputNumber id="cotacao_valor_desconto" v-model="form.cotacao_valor_desconto" :minFractionDigits="2" :maxFractionDigits="5" fluid readonly />
                        <label for="cotacao_valor_desconto">Valor com Desconto</label>
                    </FloatLabel>
                </InputGroup>
            </div>
            <div class="w-4">
                <InputGroup>
                    <InputGroupAddon>R$</InputGroupAddon>
                    <FloatLabel>
                        <InputNumber id="cotacao_valor_instalacao" v-model="form.cotacao_valor_instalacao" :minFractionDigits="2" :maxFractionDigits="5" fluid readonly />
                        <label for="cotacao_valor_instalacao">Valor Instalação</label>
                    </FloatLabel>
                </InputGroup>
            </div>
        </div>

        <div class="field mt-4 flex gap-2">
            <div class="w-12">
                <FloatLabel>
                    <Textarea id="observacoes" v-model="form.observacoes" class="w-full" rows="5" readonly />
                    <label for="observacoes">Observações</label>
                </FloatLabel>
            </div>
        </div>
    </div>

</template>
<script>
import FloatLabel from 'primevue/floatlabel';
import InputText from 'primevue/inputtext';
import Select from 'primevue/select';
import InputMask from 'primevue/inputmask';
import Checkbox from 'primevue/checkbox';
import AutoComplete from 'primevue/autocomplete';
import DatePicker from 'primevue/datepicker';
import InputNumber from 'primevue/inputnumber';
import Textarea from 'primevue/textarea';
import Button from 'primevue/button';
import InputGroup from 'primevue/inputgroup';
import InputGroupAddon from 'primevue/inputgroupaddon';
import Panel from 'primevue/panel';

export default {
    components: { FloatLabel,
                  InputGroup,
                  InputGroupAddon,
                  Button,
                  InputText,
                  InputMask,
                  Select,
                  Textarea,
                  AutoComplete,
                  Checkbox,
                  DatePicker,
                  InputNumber,
                  Panel,
                },
    props: {
        form: {},
        errors: {},
        permissoes: {},
    },
    emits: ['save','close','consultaCep','selectCliente'],
    data() {
        return {
            isLoading: false,
        }
    },
    methods: {}
}
</script>

<style>
    .contrato-endereco .p-panel-header {
        padding-bottom: 0;
    }
</style>
